import styles from './index.less';
import { useEffect, useState } from 'react';
import NoData from '@/components/NoData';
import {  viewWechatAboutPage } from '@/service/banner';
import { Helmet, useLocation } from '@umijs/max';
import { Card } from 'react-vant';


const AboutPropertyDetail = () => {
  console.log(666, useLocation());
  const location = useLocation();
  const data = new URLSearchParams(location.search).get('sequenceNbr');

  console.log(data)
  const [AboutPropertyData, setAboutPropertyData] = useState<any>({});
  useEffect(() => {
    viewWechatAboutPage({sequenceNbr: data}).then((res) => {
      console.log(res);
      if (res && res.code === 200 && res.data) {
        setAboutPropertyData(res.data);
      } else {
        setAboutPropertyData({});
      }
    });
    
  }, [data]);
  

  return (
    <div className={styles['aboutPropertyDetail']}>
      <Helmet>
        <title>物业详情</title>
      </Helmet>
      <div>
        {Object.entries(AboutPropertyData).length ? (
          <>
            <div className={styles['datailsBox']}>
              <div className={styles['title']}>{AboutPropertyData.title}</div>
              <div className={styles.quetionContaner}>
                <Card round>
                      <Card.Body>
                        <div
                          className={styles.content}
                          dangerouslySetInnerHTML={{
                            __html: AboutPropertyData.content,
                          }}
                        ></div> 
                        </Card.Body>
                  </Card>
               </div>
            </div>
          </>
        ) : (
          <NoData />
        )}
      </div>
    </div>
  );
};

export default AboutPropertyDetail;
